/* components/Navigation.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	null_to_empty,
	run_all,
	safe_not_equal,
	stop_propagation
} from "svelte/internal";

import store from "../store";

function add_css() {
	var style = element("style");
	style.id = "svelte-1f0sun6-style";
	style.textContent = ".menu.svelte-1f0sun6.svelte-1f0sun6{position:fixed;z-index:9999;counter-reset:item;list-style-type:none}@media screen and (min-width: 1200px){.menu.svelte-1f0sun6.svelte-1f0sun6{top:50%;transform:translate3d(0, -50%, 0)}}@media screen and (max-width: 1199px){.menu.svelte-1f0sun6.svelte-1f0sun6{top:0;box-sizing:border-box}}.menu.svelte-1f0sun6 ul.svelte-1f0sun6{margin:0;padding:0}.menu__toggle.svelte-1f0sun6.svelte-1f0sun6{width:20px;height:12px;padding:18px;display:block;position:fixed;cursor:pointer;top:10px;left:10px;z-index:1000;outline:none;transform:rotate(0deg);transition:0.5s ease-in-out;background:rgba(25,47,59,0.4);backdrop-filter:blur(12px);box-sizing:border-box;background:transparent}@media screen and (min-width: 768px){.menu__toggle.svelte-1f0sun6.svelte-1f0sun6{left:28px}}@media screen and (min-width: 1200px){.menu__toggle.svelte-1f0sun6.svelte-1f0sun6{display:none}}.menu__toggle.svelte-1f0sun6 span.svelte-1f0sun6{display:block;position:absolute;width:20px;height:2px;background-color:#29abe2;opacity:1;left:8px;transform:rotate(0deg);transition:0.25s ease-in-out}.menu__toggle.svelte-1f0sun6 span.svelte-1f0sun6:nth-child(1){top:11px}.menu__toggle.svelte-1f0sun6 span.svelte-1f0sun6:nth-child(2),.menu__toggle.svelte-1f0sun6 span.svelte-1f0sun6:nth-child(3){top:18px}.menu__toggle.svelte-1f0sun6 span.svelte-1f0sun6:nth-child(4){top:25px}.menu_open.svelte-1f0sun6 .menu__toggle span.svelte-1f0sun6:nth-child(1){top:20px;width:0;left:50%}.menu_open.svelte-1f0sun6 .menu__toggle span.svelte-1f0sun6:nth-child(2){transform:rotate(45deg);background:#29abe2}.menu_open.svelte-1f0sun6 .menu__toggle span.svelte-1f0sun6:nth-child(3){transform:rotate(-45deg);background:#29abe2}.menu_open.svelte-1f0sun6 .menu__toggle span.svelte-1f0sun6:nth-child(4){top:20px;width:0;left:50%}li.success.svelte-1f0sun6.svelte-1f0sun6::after{content:'';display:block;width:12px;height:12px;position:absolute;left:15px;top:50%;transform:translateY(-50%);background-position:center;background-size:contain;background-repeat:no-repeat;background-image:url(\"data:image/svg+xml,%3Csvg width='14' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 6.451v.552A6 6 0 119.442 1.52M13 2.203L7 8.21l-1.8-1.8' stroke='%2329ABE2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")}@media screen and (min-width: 1200px){li.success.svelte-1f0sun6.svelte-1f0sun6::after{left:20px}}@media screen and (max-width: 1199px){.menu.svelte-1f0sun6 ul.svelte-1f0sun6{padding-top:60px;display:none;padding-right:15px}.menu_open.svelte-1f0sun6.svelte-1f0sun6{width:100%;height:100vh;background:#000}.menu_open.svelte-1f0sun6 ul.svelte-1f0sun6{display:block;height:100%;overflow:auto}}.menu.svelte-1f0sun6 li.svelte-1f0sun6{display:block;position:relative;padding-left:40px}@media screen and (min-width: 768px){.menu.svelte-1f0sun6 li.svelte-1f0sun6{margin-top:20px}}@media screen and (min-width: 960px){.menu.svelte-1f0sun6 li.svelte-1f0sun6{margin-top:0}}@media screen and (min-width: 768px){.menu.svelte-1f0sun6 li.svelte-1f0sun6:first-child{margin-top:0}}.menu.svelte-1f0sun6 li.first.svelte-1f0sun6{display:none}.menu.svelte-1f0sun6 li.svelte-1f0sun6:before{content:'';position:absolute;height:100%;width:66px;left:0;top:0;opacity:0;background:linear-gradient(90deg, rgba(41,171,226,0.4) -1.16%, rgba(41,171,226,0) 76.74%);transition:0.25s ease-out}.menu.svelte-1f0sun6 a.svelte-1f0sun6{display:block;position:relative;color:#33627a;text-decoration:none;font-family:'Averta CY', sans-serif;line-height:1.9;font-size:16px;transition:0.25s ease-out}@media screen and (min-width: 375px){.menu.svelte-1f0sun6 a.svelte-1f0sun6{line-height:2.5}}@media screen and (min-width: 480px){.menu.svelte-1f0sun6 a.svelte-1f0sun6{font-size:16px}}@media screen and (min-width: 768px){.menu.svelte-1f0sun6 a.svelte-1f0sun6{font-size:24px;line-height:36px}}@media screen and (min-width: 960px){.menu.svelte-1f0sun6 a.svelte-1f0sun6{line-height:2.5;font-size:12px;font-weight:600;white-space:nowrap}.menu.svelte-1f0sun6 a.svelte-1f0sun6:before{content:counter(item, decimal-leading-zero) \" \";counter-increment:item;font-family:'Averta CY', sans-serif;display:inline-block;color:#33627a;margin-right:10px}}.menu.svelte-1f0sun6 .active a.svelte-1f0sun6{color:#fff}.menu.svelte-1f0sun6 .active.svelte-1f0sun6:before{border-left:2px solid #29abe2;opacity:1}.menu.svelte-1f0sun6 li.svelte-1f0sun6:hover:before{opacity:1}@media screen and (min-width: 1200px){.menu__toggle.svelte-1f0sun6.svelte-1f0sun6{display:none}.menu.svelte-1f0sun6 span.svelte-1f0sun6{display:none;position:absolute;top:0;left:0}.menu.svelte-1f0sun6 a.svelte-1f0sun6:hover:before,.menu.svelte-1f0sun6 .active a.svelte-1f0sun6:before{opacity:0}.menu.svelte-1f0sun6 .active span.svelte-1f0sun6{display:block}.menu.svelte-1f0sun6 a:hover span.svelte-1f0sun6{display:block;color:#29abe2}}@media screen and (max-width: 1199px){.menu.svelte-1f0sun6 a.svelte-1f0sun6{color:#fff}.menu.svelte-1f0sun6 .active a.svelte-1f0sun6{color:#29abe2}}@media(min-width: 1209px) and (max-width: 1350px){.menu.svelte-1f0sun6 li span.svelte-1f0sun6,.menu.svelte-1f0sun6 a:hover span.svelte-1f0sun6,.menu.svelte-1f0sun6 .active span.svelte-1f0sun6{display:none}.menu.svelte-1f0sun6 .active a.svelte-1f0sun6:before{opacity:1;color:#fff}}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div;
	let button;
	let ul;
	let li0;
	let li1;
	let li2;
	let li3;
	let a3;
	let li3_class_value;
	let li4;
	let li5;
	let a5;
	let li5_class_value;
	let li6;
	let li7;
	let li8;
	let li9;
	let li10;
	let li11;
	let li12;
	let li13;
	let li14;
	let div_class_value;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			button = element("button");
			button.innerHTML = `<span class="svelte-1f0sun6"></span><span class="svelte-1f0sun6"></span><span class="svelte-1f0sun6"></span><span class="svelte-1f0sun6"></span>`;
			ul = element("ul");
			li0 = element("li");
			li0.innerHTML = `<a href="#/" class="svelte-1f0sun6">/</a>`;
			li1 = element("li");
			li1.innerHTML = `<a href="#intro" class="svelte-1f0sun6"><span class="svelte-1f0sun6">Intro</span></a>`;
			li2 = element("li");
			li2.innerHTML = `<a href="#fungible-vs-non-fungible" class="svelte-1f0sun6"><span class="svelte-1f0sun6">Fungible vs. non-fungible</span></a>`;
			li3 = element("li");
			a3 = element("a");
			a3.innerHTML = `<span class="svelte-1f0sun6">What can a NFT represent?</span>`;
			li4 = element("li");
			li4.innerHTML = `<a href="#why-are-NFTs-exciting" class="svelte-1f0sun6"><span class="svelte-1f0sun6">Why are NFTs exciting?</span></a>`;
			li5 = element("li");
			a5 = element("a");
			a5.innerHTML = `<span class="svelte-1f0sun6">Guess how much Dragon worth ETH?</span>`;
			li6 = element("li");
			li6.innerHTML = `<a href="#NFT-use-cases" class="svelte-1f0sun6"><span class="svelte-1f0sun6">NFT use cases</span></a>`;
			li7 = element("li");
			li7.innerHTML = `<a href="#what-are-the-best-known-projects" class="svelte-1f0sun6"><span class="svelte-1f0sun6">What are the best-known projects?</span></a>`;
			li8 = element("li");
			li8.innerHTML = `<a href="#a-blockchain-game-in-action" class="svelte-1f0sun6"><span class="svelte-1f0sun6">A blockchain game in action</span></a>`;
			li9 = element("li");
			li9.innerHTML = `<a href="#big-brands-getting-into-NFTs" class="svelte-1f0sun6"><span class="svelte-1f0sun6">Big brands getting into NFTs</span></a>`;
			li10 = element("li");
			li10.innerHTML = `<a href="#the-most-expensive-NFTs-sold-in-2019" class="svelte-1f0sun6"><span class="svelte-1f0sun6">The most expensive NFTs sold in 2019</span></a>`;
			li11 = element("li");
			li11.innerHTML = `<a href="#the-pros-and-cons-of-NFTs" class="svelte-1f0sun6"><span class="svelte-1f0sun6">The pros and cons of NFTs</span></a>`;
			li12 = element("li");
			li12.innerHTML = `<a href="#how-are-NFTs-made" class="svelte-1f0sun6"><span class="svelte-1f0sun6">How are NFTs made?</span></a>`;
			li13 = element("li");
			li13.innerHTML = `<a href="#NFT-industry-stats" class="svelte-1f0sun6"><span class="svelte-1f0sun6">NFT industry stats</span></a>`;
			li14 = element("li");
			li14.innerHTML = `<a href="#big-NFT-news-in-2020" class="svelte-1f0sun6"><span class="svelte-1f0sun6">Big NFT news in 2020 (so far)</span></a>`;
			attr(button, "class", "menu__toggle card svelte-1f0sun6");
			attr(li0, "class", "first svelte-1f0sun6");
			attr(li0, "data-menuanchor", "/");
			attr(li1, "data-menuanchor", "intro");
			attr(li1, "class", "svelte-1f0sun6");
			attr(li2, "data-menuanchor", "fungible-vs-non-fungible");
			attr(li2, "class", "svelte-1f0sun6");
			attr(a3, "href", "#what-can-a-nft-represent");
			attr(a3, "class", "svelte-1f0sun6");
			attr(li3, "class", li3_class_value = "" + (null_to_empty(/*quiz1SectionClass*/ ctx[1]) + " svelte-1f0sun6"));
			attr(li3, "data-menuanchor", "what-can-a-nft-represent");
			attr(li4, "data-menuanchor", "why-are-NFTs-exciting");
			attr(li4, "class", "svelte-1f0sun6");
			attr(a5, "href", "#guess-how-much-dragon-worth-ETH");
			attr(a5, "class", "svelte-1f0sun6");
			attr(li5, "class", li5_class_value = "" + (null_to_empty(/*quiz2SectionClass*/ ctx[2]) + " svelte-1f0sun6"));
			attr(li5, "data-menuanchor", "guess-how-much-dragon-worth-ETH");
			attr(li6, "data-menuanchor", "NFT-use-cases");
			attr(li6, "class", "svelte-1f0sun6");
			attr(li7, "data-menuanchor", "what-are-the-best-known-projects");
			attr(li7, "class", "svelte-1f0sun6");
			attr(li8, "data-menuanchor", "a-blockchain-game-in-action");
			attr(li8, "class", "svelte-1f0sun6");
			attr(li9, "data-menuanchor", "big-brands-getting-into-NFTs");
			attr(li9, "class", "svelte-1f0sun6");
			attr(li10, "data-menuanchor", "the-most-expensive-NFTs-sold-in-2019");
			attr(li10, "class", "svelte-1f0sun6");
			attr(li11, "data-menuanchor", "the-pros-and-cons-of-NFTs");
			attr(li11, "class", "svelte-1f0sun6");
			attr(li12, "data-menuanchor", "how-are-NFTs-made");
			attr(li12, "class", "svelte-1f0sun6");
			attr(li13, "data-menuanchor", "NFT-industry-stats");
			attr(li13, "class", "svelte-1f0sun6");
			attr(li14, "data-menuanchor", "big-NFT-news-in-2020");
			attr(li14, "class", "svelte-1f0sun6");
			attr(ul, "class", "svelte-1f0sun6");
			attr(div, "class", div_class_value = "menu " + /*openedMenuClass*/ ctx[0] + " svelte-1f0sun6");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, button);
			append(div, ul);
			append(ul, li0);
			append(ul, li1);
			append(ul, li2);
			append(ul, li3);
			append(li3, a3);
			append(ul, li4);
			append(ul, li5);
			append(li5, a5);
			append(ul, li6);
			append(ul, li7);
			append(ul, li8);
			append(ul, li9);
			append(ul, li10);
			append(ul, li11);
			append(ul, li12);
			append(ul, li13);
			append(ul, li14);

			if (!mounted) {
				dispose = [
					listen(button, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li0, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li1, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li2, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li3, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li4, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li5, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li6, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li7, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li8, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li9, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li10, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li11, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li12, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li13, "click", stop_propagation(/*handleToggleMenu*/ ctx[3])),
					listen(li14, "click", stop_propagation(/*handleToggleMenu*/ ctx[3]))
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*quiz1SectionClass*/ 2 && li3_class_value !== (li3_class_value = "" + (null_to_empty(/*quiz1SectionClass*/ ctx[1]) + " svelte-1f0sun6"))) {
				attr(li3, "class", li3_class_value);
			}

			if (dirty & /*quiz2SectionClass*/ 4 && li5_class_value !== (li5_class_value = "" + (null_to_empty(/*quiz2SectionClass*/ ctx[2]) + " svelte-1f0sun6"))) {
				attr(li5, "class", li5_class_value);
			}

			if (dirty & /*openedMenuClass*/ 1 && div_class_value !== (div_class_value = "menu " + /*openedMenuClass*/ ctx[0] + " svelte-1f0sun6")) {
				attr(div, "class", div_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			run_all(dispose);
		}
	};
}

const successClass = "success";

function instance($$self, $$props, $$invalidate) {
	let $store;
	component_subscribe($$self, store, $$value => $$invalidate(5, $store = $$value));
	let isMenuOpened;
	let openedMenuClass;
	let quiz1SectionClass;
	let quiz2SectionClass;

	const handleToggleMenu = () => {
		$$invalidate(4, isMenuOpened = !isMenuOpened);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$store*/ 32) {
			$: $$invalidate(1, quiz1SectionClass = $store.hasQuiz1SuccessAnswer ? successClass : "");
		}

		if ($$self.$$.dirty & /*$store*/ 32) {
			$: $$invalidate(2, quiz2SectionClass = $store.hasQuiz2SuccessAnswer ? successClass : "");
		}

		if ($$self.$$.dirty & /*isMenuOpened*/ 16) {
			$: $$invalidate(0, openedMenuClass = isMenuOpened ? "menu_open" : "");
		}
	};

	return [openedMenuClass, quiz1SectionClass, quiz2SectionClass, handleToggleMenu];
}

class Navigation extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1f0sun6-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Navigation;